<template>
  <div class="child_information_add">
    <div class="child_information_add_form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="child_information_add_ruleForm">
           <div class="scorll-height">
              <div class="ruleForm_block">
              <el-form-item class="ruleForm_block_headImg span5 margin18">
                 <span slot="label" class="ruleForm_block_label">
                    <span>头</span>
                    <span>像</span>
                 </span>
                 <van-uploader :after-read="afterRead" accept="image/jpg, image/jpeg">
                 <span class="ruleForm_block_imgs">
                     <img :src="headImg" class="ruleForm_block__pic">
                 </span>
                 </van-uploader>
              </el-form-item>
              <el-form-item prop="relationShip" class="ruleForm_block_relationShip is_required span5">
                 <span slot="label" class="ruleForm_block_label">
                    <span>与</span>
                    <span>家</span>
                    <span>长</span>
                    <span>关</span>
                    <span>系</span>
                 </span>
                 <div class="ruleForm_block_relationShip_select">
                    <select-box
                     :inputValue="ruleForm.relationShip"
                     :options="relationOption"
                     @selectChange="relationChange"
                     ></select-box>
                 </div>
              </el-form-item>
           </div>
           <div class="ruleForm_block">
              <el-form-item prop="sex" class="ruleForm_block_sex is_required span5 margin18">
                 <span slot="label" class="ruleForm_block_label">
                    <span>性</span>
                    <span>别</span>
                 </span>
                 <div class="ruleForm_block_sex_select">
                    <select-box
                     :inputValue="ruleForm.sex"
                     :options="sexOption"
                     @selectChange="sexChange"
                     ></select-box>
                 </div>
              </el-form-item>
              <el-form-item prop="nickName" class="ruleForm_block_nickName span5">
                 <span slot="label" class="ruleForm_block_label">
                    <span>昵</span>
                    <span>称</span>
                 </span>
                 <el-input v-model="ruleForm.nickName"></el-input>
              </el-form-item>
           </div>
           <div class="ruleForm_block">
              <el-form-item prop="age" class="ruleForm_block_age margin18 span5">
                 <span slot="label" class="ruleForm_block_label">
                    <span>年</span>
                    <span>龄</span>
                 </span>
                 <el-input v-model="ruleForm.age" maxlength="3"></el-input>
              </el-form-item>
              <el-form-item prop="studentName" class="ruleForm_block_studentName is_required span5">
                 <span slot="label" class="ruleForm_block_label">
                    <span>姓</span>
                    <span>名</span>
                 </span>
                 <el-input v-model.trim="ruleForm.studentName" ></el-input>
              </el-form-item>

           </div>
           <div class="ruleForm_block">
              <el-form-item class="ruleForm_block_signs  span5 margin18">
                 <span slot="label" class="ruleForm_block_label">
                    <span>星</span>
                    <span>座</span>
                 </span>
                 <div class="ruleForm_block_signs_select">
                    <select-box
                     :inputValue="ruleForm.signs"
                     :options="signsOption"
                     @selectChange="signsChange"
                     ></select-box>
                 </div>
              </el-form-item>
              <el-form-item  prop="birthday" :required="ruleForm.birthday?true:false" class="ruleForm_block_birthday is_required span5">
                 <span slot="label" class="ruleForm_block_label">
                    <span>出</span>
                    <span>生</span>
                    <span>日</span>
                    <span>期</span>
                 </span>
                 <span class="ruleForm_block_birthday" @click="editBirthday">
                     <el-input v-model="ruleForm.birthday" readonly></el-input>
                     <i class="ruleForm_block_birthday_icon"></i>
                  </span>
              </el-form-item>
           </div>
           <div class="ruleForm_block">
               <el-form-item label="班级"  class="ruleForm_block_classes is_required">
                 <span slot="label" class="ruleForm_block_label">
                    <span>班</span>
                    <span>级</span>
                 </span>
                 <el-form-item class="ruleForm_block_classes_genderNo" prop="genderNo">
                     <select-box
                     :inputValue="ruleForm.genderNo"
                     :options="genderOption"
                     @selectChange="genderChange"
                     ></select-box>
                  </el-form-item>
                  <span class="ruleForm_block_classes_genderName">年</span>
                  <el-form-item class="ruleForm_block_classes_classNameNo" prop="classNameNo">
                     <select-box
                     :inputValue="ruleForm.classNameNo"
                     :options="classOption"
                     @selectChange="classChange"
                     ></select-box>
                  </el-form-item>
                  <span class="ruleForm_block_classes_className">班</span>
              </el-form-item>
           </div>
           <div class="ruleForm_block">
              <el-form-item prop="schoolNo" class="ruleForm_block_school is_required">
                 <span slot="label" class="ruleForm_block_label">
                    <span>学</span>
                    <span>校</span>
                 </span>
                 <div class="ruleForm_block_school_select">
                    <!-- <select-box
                     :inputValue="ruleForm.school"
                     :options="schoolOption"
                     ></select-box> -->
                     <search-more v-model="ruleForm.schoolNo" @change="schoolChange"></search-more>
                 </div>
              </el-form-item>
           </div>
           <div class="ruleForm_block">
               <el-form-item prop="idCard" class="ruleForm_block_idCard">
                  <span slot="label" class="ruleForm_block_label">
                    <span>身</span>
                    <span>份</span>
                    <span>证</span>
                    <span>号</span>
                 </span>
                  <el-input v-model="ruleForm.idCard" @blur="onBlur"></el-input>
               </el-form-item>
           </div>
           <div class="ruleForm_block">
               <el-form-item  class="ruleForm_block_address">
                  <span slot="label" class="ruleForm_block_label">
                    <span>所</span>
                    <span>在</span>
                    <span>地</span>
                  </span>
                  <span class="ruleForm_block_address_province" @click="editAddress">
                     <el-input v-model="province" readonly></el-input>
                     <i class="ruleForm_block_address_name">省</i>
                  </span>
                  <span class="ruleForm_block_address_city" @click="editAddress">
                     <el-input v-model="city" readonly></el-input>
                     <i class="ruleForm_block_address_name">市</i>
                  </span>
                  <span class="ruleForm_block_address_county" @click="editAddress">
                     <el-input v-model="county" readonly></el-input>
                     <i class="ruleForm_block_address_name">区/县</i>
                  </span>
               </el-form-item>
           </div>
           <div class="ruleForm_block">
              <el-form-item prop="personalSignature" class="ruleForm_block_personalSignature">
                 <span slot="label" class="ruleForm_block_label">
                    <span>个</span>
                    <span>性</span>
                    <span>签</span>
                    <span>名</span>
                 </span>
                  <el-input v-model="ruleForm.personalSignature" placeholder="请输入个性签名"></el-input>
               </el-form-item>
           </div>
           <div class="ruleForm_block_btns">
              <span class="ruleForm_block_btns_add" @click="submit('ruleForm')">新增</span>
            </div>
           </div>
        </el-form>
    </div>
    <!-- 地址 -->
       <van-popup v-model="showPicker" round position="bottom">
         <van-area
         :area-list="areaList"
         :columns-num="3"
          title="地域"
          :value="showCode"
         :is-horizontal="true"
         @cancel="showPicker=false"
         @confirm="onAreaConfirm"
         ></van-area>
      </van-popup>
      <!-- 日历 -->
      <van-popup v-model="showDatePicker" round position="bottom">
         <van-datetime-picker
         v-model="currentDate"
         :min-date="minDate"
         :max-date="maxDate"
         :is-horizontal="true"
         type="date"
         :filter="filter"
         title="选择出生日期"
         @cancel="showDatePicker=false"
         @confirm="onConfirm"
         />
      </van-popup>
  </div>
</template>

<script>
import selectBox from './select-box.vue';
import searchMore from './search-more.vue';
import { areaList } from '@vant/area-data';
import { _getList,_getSigns,_getBirthdayAndAgeAndSigns,_saveChild } from '../../api/children-file';
import { _upload } from '../../api/family-archives';
import { _schoolSearch } from "../../api/home";
import {ages} from '../../assets/js/util.js';
import BScroll from "better-scroll";
export default {
   name:"add-basic-information",
   props:{
      componentData:{
         type:Object
      },
      sex:{
         type:Number
      },
   },
   components:{
      selectBox,
      searchMore,
   },
   data() {
      let checkIdcard  = (rule, value, callback) => {
        let regexp = "(^[1-9]\\d{5}(18|19|20)\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|"
            + "(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}$)";
         let reg = new RegExp(regexp)
       if (value && !reg.test(value)) {
          callback(new Error('身份证号格式不正确，请重新输入'));
        } else {
          callback();
        }
      };
      let checkAge = (rule, value, callback) =>{
         let reg = /^([1-9]\d*)$/;
         if(value && !reg.test(value)){
            callback(new Error('请输入正确的年龄'));
         }else{
            callback();
         }
      };
      let checkSignature = (rule, value, callback) => {
        if (value.length > 100) {
          callback(new Error('个性签名最多100个字'));
        } else {
          callback();
        }
      };
      return {
         ruleForm:{
            signs:"", // 星座
            studentName:"", // 姓名
            sex:"", // 性别
            gender:'', // 年级名称
            genderNo:"", // 年级
            className:'', // 班级名称
            classNameNo:"", // 班级
            age:"", // 年龄
            relation:'', // 与家长的关系名称
            relationShip:"", // 与家长的关系
            birthday:"", // 出生日期
            school:"", // 学校名称
            schoolNo:'', // 学校code
            idCard:"", // 身份证号
            personalSignature:"", // 个性签名
            nickName:'', //昵称
         },
         showCode:'',
         headImg:require('../../assets/images/head/boy.png'), // 头像
         // nickName:"", // 昵称
         province:"", // 省
         city:"", // 市
         county:"", // 区
         areaList,
         rules:{
            studentName:[
               {required:true,message:"请输入学生姓名",trigger:'blur'},
               { min: 1, max: 6, message: '学生姓名最多支持6个字符', trigger: 'blur'}
            ],
            sex:[{required:true,message:"请选择性别",trigger:'blur'}],
            genderNo:[{required:true,message:"请选择年级",trigger:'blur'}],
            classNameNo:[{required:true,message:"请选择班级",trigger:'blur'}],
            age:[{validator:checkAge ,trigger:'blur'}],
            relationShip:[{required:true,message:"请选择与家长关系",trigger:'blur'}],
            birthday:[{required:true,message:"请选择出生日期",trigger:'blur'}],
            schoolNo:[{required:true,message:"请选择学校",trigger:'blur'},{
              validator:this.scoolValidator,message: '请从检索结果中选择所在学校',trigger:'change'
            }],
            idCard:[{ validator: checkIdcard, trigger: 'blur'}],
            personalSignature:[{ validator: checkSignature, trigger: 'blur'}],
            nickName:[{min: 0, max: 6, message: '昵称最多支持6个字符', trigger: 'blur'}]
         },
         sexOption:[
            {label:"男",value:'1'},
            {label:"女",value:'2'}
         ],
         genderOption:[], // 年级列表
         classOption:[], // 班级列表
         signsOption:[], // 星座
         relationOption:[], // 家长关系列表
         schoolOption:[], // 学校列表
         showPicker:false, // 默认不展示地域弹框
         showDatePicker:false, // 默认不展示日历弹框
         currentDate:new Date(),
         minDate: new Date(1900, 0, 1),// 最小日期
         selectType:'select',// 下拉框
         pic:'', // 头像
      }
   },
   computed:{
		maxDate() {
			let now = new Date()
			let nowYear = now.getFullYear() - 8;
			let nowDay = now.getDate();
			let newMonth = now.getMonth();
			return new Date(nowYear,newMonth,nowDay)
		}
	},
   watch:{
      sex:{
         handler(val){
            this.headImg = val == 1 ? require('../../assets/images/head/boy.png') : require('../../assets/images/head/girl.png');
         },
         immediate:true,
         deep:true
      },
   },
   created() {
       // 年级字典
      _getList('grade').then(res=>{
         if(res.code == 200){
            let dataList = res.data;
            dataList.map(item=>{
               this.genderOption.push({label:item.name,value:item.code})
            })
         }else{
            Toast({message:res.message,className:'rotation'})
         }
      })
      // 班级
       _getList('class').then(res=>{
         if(res.code == 200){
            let dataList = res.data;
            dataList.map(item=>{
               this.classOption.push({label:item.name,value:item.code})
            })
         }else{
            Toast({message:res.message,className:'rotation'})
         }
      })
      // 星座
      _getSigns().then(res=>{
         if(res.code == 200){
            this.signsOption = res.data;
         }else{
            Toast({message:res.message,className:'rotation'})
         }
      })
      // 与家长的关系
      _getList('relationShip').then(res=>{
         if(res.code == 200){
            let dataList = res.data;
            dataList.map(item=>{
               this.relationOption.push({label:item.name,value:item.code})
            })
         }else{
            Toast({message:res.message,className:'rotation'})
         }
      })
      // 学校
      _schoolSearch({
				keywords:""
			}).then((res)=>{
				if(res && res.code==200){
					if (res.data) {
						this.schoolOption = res.data;
					}
				}else {
					Toast({message:res.message,className:'rotation'});
				}
			})

   },
   mounted() {
      this.$nextTick(()=>{
         let bs = new BScroll('.child_information_add_ruleForm',{
            pullUpLoad: true, // 不触发上拉事件
            scrollbar: true, // 展示滚动条
            pullDownRefresh: true, // 开启下拉刷新事件，需要配合内部配置使用，这里目前没有用到
            scrollX:false, // 关闭横向滚动功能
            quadrant:2, // 父元素或者祖先元素旋转的角度为 (45, 135]，quadrant 建议为 2，尤其是 90 度，quadrant 必须为 2
            bounce:false, // 关闭滚动到边缘时的回弹动作
            click:true, // 开启点击事件
            stopPropagation:true // 阻止事件冒泡
         })
      })
   },
   methods:{
     scoolValidator(rule, item, callback){
       let schoolName = document.querySelector(".search_more_input_custom");
       console.log(item,this.ruleForm.school , schoolName.value
         && this.ruleForm.schoolNo == item)
       if (this.ruleForm.school == schoolName.value
         && this.ruleForm.schoolNo == item) {
         callback();
       }else{
         callback(new Error(""))
       }
     },
      // 控制儿童出生日期
		filter(type,options) {
			let now = new Date()
			let nowYear = now.getFullYear();
			if(type == 'year'){
				return options.filter((option)=> Number(option)+8 <= nowYear)
			}
			return options
		},
      // 输入身份证后根据身份证查询对应的星座
      onBlur() {
         if(this.ruleForm.idCard){
            this.queryBirthdayAndAgeAndSigns(this.ruleForm.idCard);
         }

      },

      // 根据身份证号获取星座和生日，年龄
      queryBirthdayAndAgeAndSigns(idCard) {
         _getBirthdayAndAgeAndSigns(idCard).then(res => {
            if(res.code == 200){
               let data = res.data
               this.ruleForm.age = data.age;
               this.ruleForm.birthday = data.birthday;
               this.ruleForm.signs = data.signs.name;
               this.currentDate = new Date(data.birthday)
            }else{
               Toast({message:res.message,className:'rotation'})
            }
         })
      },
      save() {
         let params = {
            id:"", // 主键id
            headImg:this.pic, // 头像
            studentName:this.ruleForm.studentName, // 学生姓名
            nickName:this.ruleForm.nickName, // 学生昵称
            sex:this.ruleForm.sex, // 学生性别
            school:this.ruleForm.school, // 学校名称 name
            schoolNo:this.ruleForm.schoolNo,//  code
            gender:this.ruleForm.gender,// 年级名称
            genderNo:this.ruleForm.genderNo, // 年级
            className:this.ruleForm.className,
            classNameNo:this.ruleForm.classNameNo, // 班级
            idCard:this.ruleForm.idCard, // 身份证
            birthday:this.ruleForm.birthday, // 生日
            age:this.ruleForm.age, // 年龄
            signs:this.ruleForm.signs || null, // 星座
            province:this.province, // 省
            city:this.city, // 市
            county:this.county, // 区
            personalSignature:this.ruleForm.personalSignature, // 个性签名
            relation:this.ruleForm.relation, // 与家长关系
            relationNo:this.ruleForm.relationShip,//
            relationOther:''// 其他关系
         }
         _saveChild(params).then(res=>{
            if(res.code == 200){
               Toast({message:'新增儿童成功',className:"rotation"});
               this.$emit('saveChild',res.data)
            }else{
               Toast({message:res.message,className:"rotation"});
            }
         })
      },
      // 新增
      submit(formName) {
         this.$refs[formName].validate((valid)=>{
            if(valid){
               this.save()
            }else{
               return false
            }
         })
      },
      // 图片读取完后的回调函数
      afterRead(file) {
         const data = new FormData()
			data.append('file',file.file)
			_upload(data).then((res)=>{
			  if(res.code =='200'){
			    this.headImg = file.content;
				 this.pic = res.data;
			  }else{
			    Toast({message:res.message,className:'rotation'})
			  }
			})
      },
      // 确认选择的出生日期
      onConfirm(value) {
         this.ruleForm.birthday = this.formatDate(value);
         this.ruleForm.age = ages(this.formatDate(value));
         this.showDatePicker = false;
      },
      //格式化日期
      formatDate(val) {
         var y = val.getFullYear();
         var m = val.getMonth() + 1;
         m = m < 10 ? "0" + m : m;
         var d = val.getDate();
         d = d < 10 ? "0" + d : d;
         return y + "-" + m + "-" + d;
      },
      // 选择所在地
      onAreaConfirm(e) {
         this.province = e[0].name;
			this.city = e[1].name;
			this.county = e[2].name;
         this.showPicker = false
      },
      // 编辑地址
      editAddress() {
         // this.$emit('editAddress')
         this.showPicker = true;
         // 解决滚动条transfrom对定位的影响
         document.getElementsByClassName('scorll-height')[0].style.transform = 'none';
         document.getElementsByClassName('bscroll-indicator')[0].style.transform = 'none';
      },
      // 编辑出生日期
      editBirthday() {
         this.showDatePicker = true;
         // 解决滚动条transfrom对定位的影响
         document.getElementsByClassName('scorll-height')[0].style.transform = 'none';
         document.getElementsByClassName('bscroll-indicator')[0].style.transform = 'none';
      },
      sexChange(item) {
         this.ruleForm.sex = item.value;
         if(item.value == '1'){
            this.headImg = this.pic ? this.pic : require('../../assets/images/head/boy.png');
         }else{
            this.headImg = this.pic ? this.pic : require('../../assets/images/head/girl.png');
         }

      },
      genderChange(item) {
         this.ruleForm.genderNo = item.value;
         this.ruleForm.gender = item.label;
      },
      classChange(item) {
         this.ruleForm.className = item.label;
         this.ruleForm.classNameNo = item.value;
      },
      signsChange(item) {
         this.ruleForm.signs = item.value;
      },
      relationChange(item) {
         this.ruleForm.relationShip = item.value;
         this.ruleForm.relation = item.label;
      },
      schoolChange(item) {
         this.ruleForm.school = item.label;
         this.ruleForm.schoolNo = item.value;
      },
   }
}
</script>

<style lang="scss" scoped>
.child_information_add{
   width:100%;
   height:100%;
   // 弹框样式
   ::v-deep .van-picker__cancel{
      color:#666666;
      font-size:16px;
      font-weight:400;
      font-family: PingFangSC-Regular, PingFang SC;
   }
   ::v-deep .van-picker__confirm{
      font-size:16px;
      color:#FF8340;
      font-weight:400;
      font-family: PingFangSC-Regular, PingFang SC;
   }
   ::v-deep .van-picker__cancel, ::v-deep .van-picker__confirm{
      padding: 0 30px;
   }
   ::v-deep .van-picker__title{
      font-size:16px;
      color:#333;
      font-weight:400;
      font-family: PingFangSC-Regular, PingFang SC;
   }
   ::v-deep .van-picker-column__item{
      font-size:14px;
      font-weight:400;
      font-family: PingFangSC-Regular, PingFang SC;
      color:#999;
      &.van-picker-column__item--selected{
         color:#333;
         font-weight:500;
         font-size:16px;
         font-family: PingFangSC-Regular, PingFang SC;

      }
   }
   ::v-deep .van-picker__frame{
       background:rgba(255,131,64,0.1);
       left:0;
       right:0;
   }
   .child_information_add_form{
      width:100%;
      height:100%;
      padding:36px 63px 36px 58px;;
      .child_information_add_ruleForm{
         width:100%;
         height:100%;
         padding-right:7px;
         white-space: nowrap;
         padding-left:7px;
         overflow: hidden;
         position: relative;
         ::v-deep .bscroll-vertical-scrollbar{
            background-color: #D39B5A;
            border-radius: 4px;
            width: 8px;
            overflow:visible !important;
            opacity: 1 !important;
            z-index:100 !important;
            .bscroll-indicator{
               background-color: #FF8000 !important;
               border-radius: 4px !important;
               border-color:#FF8000 !important;
            }
         }
         /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
         .scroll-height{
            overflow-y:auto;
            // overflow: auto;
            white-space: nowrap;
         }
            // &::-webkit-scrollbar {
            //    width: 8px; /*对垂直流动条有效*/
            //    border-radius: 4px;
            //    height:100px;
            //    // height: 20px; /*对水平流动条有效*/
            // }

            // /*定义滚动条的轨道颜色、内阴影及圆角*/
            // &::-webkit-scrollbar-track{
            //    // box-shadow: 0 0 3px 0 rgba(0,0,0,0.5), 1px 0 3px 0 #8E6138;
            //    background-color: #D39B5A;
            //    border-radius: 4px;
            // }
            // &::-webkit-scrollbar-track-piece{
            //    border-radius:4px;
            // }
            // /*定义滑块颜色、内阴影及圆角*/
            // &::-webkit-scrollbar-thumb{
            //    // box-shadow: 0 0 4px 0 rgba(255,255,255,0.5),-2px 0 0 0 rgba(196,106,47,0.5);
            //    background-color: #FF8000;
            //    border-radius: 4px;
            // }
         ::v-deep .el-form-item.margin18{
            margin-right:18px;
         }
         ::v-deep .el-form-item__label{
            min-width:48px;
            height:25px;
            line-height:25px;
            // vertical-align: middle;
            // text-align: justify;
            // text-align-last: justify;
            // -moz-text-align-last: justify;
            // justify-content: space-between;
            // text-justify: distribute-all-lines;
            display: block;
            color:#74410A;
            font-size:12px;
            font-weight:500;
            padding:0;
            margin-right:8px;
            position: relative;
            font-family: PingFangSC-Regular, PingFang SC;
            .ruleForm_block_label{
               display: flex;
               justify-content: space-between;
            }
            &::before{
               // color:#FF0000;
               display: none;
            }
         }
         ::v-deep .el-input__inner{
            height:25px;
            line-height:25px;
            background: #D99649;
            border-radius:8px;
            font-size:12px;
            color:#FFF6D4;
            font-weight:500;
            padding-left:8px;
            border-color:#D99649;
            vertical-align: middle;
            // box-shadow:0 -1px 0 0 #FFF5D9;
            box-shadow: 0 1px 0 0 #FFF5D9,0 -1px 1px 0 rgba(0,0,0,0.5);
            &:focus{
               border-color:#D99649;
            }
         }
         ::v-deep .el-form-item{
            height:25px;
            line-height:25px;
            position:relative;
            margin-bottom:0;
            &.is_required::before{
               content:"*";
               display: inline-block;
               color:#FF0000;
               position: absolute;
               left:-7px;
               width:7px;
               text-align:center;
            }
         }
         ::v-deep .el-input.is-disabled .el-input__inner{
            background-color: #d99649;
            border-color: #d99649;
            color: #fff6d4;
            cursor: pointer;
         }
         ::v-deep .el-form-item__content{
            height:25px;
            line-height:25px;
         }
         .ruleForm_block{
            display: flex;
            justify-content: start;
            flex-wrap: wrap;
            ::v-deep .el-form-item__content{
               display: inline-block;
               width:auto;
               vertical-align: top;
            }
            ::v-deep .el-form-item__label{
               vertical-align: top;
            }
            &:not(:first-child){
               height:25px;
            }

            &:not(:last-child){
               margin-bottom:22px;
            }
            &:first-child{
               margin-bottom:8px;
            }
            .span5{
               width:calc(50% - 19px);
            }
            .ruleForm_block_headImg{
               // width:136px;
               line-height:40px;
               height:40px;
               // width:29.31%;
               // margin-right:3.87%;
               .ruleForm_block_imgs{
                  display: inline-block;
                  // width:80px;
                  width:calc(100% - 56px);
                  // width:58.82%;
                  ::v-deep .el-form-item__content{
                     width:100%;
                  }

               }
            }
            .ruleForm_block__pic{
               width:40px;
               height:40px;
               border-radius: 25px;
               // margin-left:4px;
            }
            .ruleForm_block_studentName{
               // margin-left:18px;
               // width:136px;

               // width:29.31%;
               // margin-right:3.87%;
               ::v-deep .el-form-item__content{
                  // width:80px;
                  // width:58.82%;
                  width:calc(100% - 56px);
                  vertical-align: top;
                  .el-input{
                     height:24px;
                  }

                  // margin-left:56px;
               }
            }
            .ruleForm_block_nickName{
               // width:136px;
               // width:29.31%;
               ::v-deep .el-form-item__content{
                  // width:80px;
                  // width:58.82%;
                  width:calc(100% - 56px);
               }
            }
            .ruleForm_block_sex{
               // width:136px;
               //  width:29.31%;
               // margin-right:18px;
               // margin-right:3.87%;
               ::v-deep .el-form-item__content{
                  // width:80px;
                  // width:58.82%;
                  width:calc(100% - 56px);
                  .ruleForm_block_sex_select{
                     width:100%;
                     .select_box_dropdown{
                        height:60px;
                     }
                  }
               }
            }
            .ruleForm_block_classes{
               width:64.21%;
               width:100%;
               ::v-deep .el-form-item__content{
                  width:calc(100% - 56px);
               }
               .ruleForm_block_classes_genderNo{
                  display: inline-block;
                  // width:100px;
                  width:calc((100% - 58px)/2);
                  margin-right:0;
                  // width:47.11%;
                  // width:46.53%;
                  ::v-deep .el-form-item__content{
                     width:100%;
                  }
               }
               .ruleForm_block_classes_classNameNo{
                  display: inline-block;
                  // width:80px;
                   width:calc((100% - 58px)/2);
                  // width:38.02%;
                  margin-right:0;
                  ::v-deep .el-form-item__content{
                     width:100%;
                  }
               }
               .ruleForm_block_classes_genderName{
                  margin:0 4px;
                  color:#74410A;
                  font-size:12px;
                  font-weight:400;
                  font-family:PingFangSC-Regular, PingFang SC;
               }
               .ruleForm_block_classes_className{
                  margin-left:4px;
                  color:#74410A;
                  font-size:12px;
                  font-weight:400;
                  font-family:PingFangSC-Regular, PingFang SC;
               }

            }
            .ruleForm_block_signs{
               // width:136px;
               // width:29.31%;
               // margin-right:18px;
               // margin-right:3.87%;
               ::v-deep .el-form-item__content{
                  // width:80px;
                  // width:58.82%;
                   width:calc(100% - 56px);
                  .ruleForm_block_sex_select{
                     width:100%;
                  }
               }
            }
            .ruleForm_block_age{
               //  width:136px;
               // width:29.31%;
               //  margin-right:18px;
               // margin-right:3.87%;
                ::v-deep .el-form-item__content{
                  // width:80px;
                  // width:58.82%;
                  width:calc(100% - 56px);
               }
            }
            .ruleForm_block_relationShip{
               // width:130px;
               // width:28.01%;
               ::v-deep .el-form-item__label{
                  width:72px;
               }
               ::v-deep .el-form-item__content{
                  // width:57px;
                  // width:43.84%;
                  width:calc(100% - 80px);
                  // width:80px;
                  vertical-align:middle;
               }
               ::v-deep .el-form-item__error{
                  left: -34px;
               }
            }
            .ruleForm_block_birthday{
               // width:167px;
               // width:35.98%;
               // margin-right:18px;
               // margin-right:3.87%;
               height:25px;
               line-height:25px;
               position: relative;
               ::v-deep .el-input__inner{
                  padding-right:26px;
               }
               ::v-deep .el-form-item__content{
                  // width:111px;
                  // width:66.46%;
                  width:calc(100% - 56px);
                  // width:104px;
               }
               .ruleForm_block_birthday_icon{
                  display: block;
                  width:14px;
                  height:14px;
                  background: url('../../assets/images/children-file/date.png') no-repeat;
                  background-size:100% 100%;
                  position: absolute;
                  right:12px;
                  top:4px;
               }
            }
            .ruleForm_block_school{
               // width:54.09%;
               width:100%;
               ::v-deep .el-form-item__content{
                  // width:260px;
                  // width:77.68%;
                  width:calc(100% - 76px);
                  height:25px;
                  line-height:25px;
               }
               .ruleForm_block_school_select{
                  height:25px;
                  line-height:25px;
               }
            }
            .ruleForm_block_idCard{
               // width:235px;
               // width:50.64%;
               width:100%;
               ::v-deep .el-form-item__content{
                  // width:179px;
                  // width:76.17%;
                  // width:260px;
                  width:calc(100% - 76px);
               }
            }
            .ruleForm_block_address{
               width:100%;
               i{
                  font-size:12px;
                  color:#FFD19F;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight:400;
                  font-style: normal;
               }
               .ruleForm_block_address_province,
               .ruleForm_block_address_city{
                  position:relative;
                  display: inline-block;
                  // width:80px;\
                  width:calc((100% - 96px)/3);
                  margin-right:10px;
                  .ruleForm_block_address_name{
                     position: absolute;
                     right:7px;
                  }
               }
               .ruleForm_block_address_county{
                  position:relative;
                  display: inline-block;
                  // width:80px;
                   width:calc((100% - 96px)/3);
                  .ruleForm_block_address_name{
                     position: absolute;
                     right:7px;
                  }
                  ::v-deep .el-input__inner{
                     padding-right:38px;
                  }
               }

            }
            .ruleForm_block_personalSignature{
               width:100%;
               ::v-deep .el-form-item__content{
                  // width:260px;
                  width:calc(100% - 76px);
               }
               ::v-deep .el-input__inner{
                  &::placeholder{
                     color:#FFF6D4;
                     font-size:12px;
                     font-weight:400;
                  }
               }
            }

         }
         .ruleForm_block_btns{
            position: relative;
            height:47px;
            margin-top:17px;
            .ruleForm_block_btns_add{
               display: block;
               width:96px;
               height:47px;
               background: url('../../assets/images/children-file/btn1.png') no-repeat;
               background-size:100% 100%;
               text-align:center;
               line-height:42px;
               color:#74410A;
               font-size:12px;
               font-weight:500;
               font-family:PingFangSC-Regular, PingFang SC;
               position: absolute;
               right:10px;
               top:-3px;
            }
         }
      }
      ::v-deep .el-form-item.is-error .el-input__inner,
      .el-form-item.is-error .el-input__inner:focus,
      .el-form-item.is-error .el-textarea__inner,
      .el-form-item.is-error .el-textarea__inner:focus,
      .el-message-box__input input.invalid,
      .el-message-box__input input.invalid:focus,
      .el-form-item.is-error ::v-deep .select_box_input_inner,
      .el-form-item.is-error ::v-deep .search_more_input_custom{
         border-color:#FF0000;
         box-shadow: 0 0 4px 0 #FFF5D9,0 -1px 1px 0 rgba(0,0,0,0.5);
      }
      ::v-deep .el-form-item__error{
         color:#FF0000;
      }
   }
}
</style>
